export function safeLocalStorageGet(key: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeLocalStorageSet(key: string, value: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    window.localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeLocalStorageRemove(key: string): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // Storage can be unavailable in private / restricted mobile browsers.
  }
}

export function safeSessionStorageGet(key: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function safeSessionStorageSet(key: string, value: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    window.sessionStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}

export function safeSessionStorageRemove(key: string): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(key);
  } catch {
    // Storage can be unavailable in private / restricted mobile browsers.
  }
}

export function safeDispatchEvent(event: Event): void {
  if (typeof window === "undefined") return;
  try {
    window.dispatchEvent(event);
  } catch {
    // Ignore optional cross-component notifications if the browser blocks them.
  }
}

export function safeRandomId(prefix = "id"): string {
  try {
    const randomUUID = globalThis.crypto?.randomUUID;
    if (typeof randomUUID === "function") return randomUUID.call(globalThis.crypto);
  } catch {
    // Some older / restricted browsers expose crypto partially or not at all.
  }
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export const safeStorage = {
  getItem: safeLocalStorageGet,
  setItem: (key: string, value: string) => {
    safeLocalStorageSet(key, value);
  },
  removeItem: safeLocalStorageRemove,
};
